import { render, staticRenderFns } from "./TextAreaDesigner.vue?vue&type=template&id=2cb45015&scoped=true&"
import script from "./TextAreaDesigner.vue?vue&type=script&lang=js&"
export * from "./TextAreaDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb45015",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb45015')) {
      api.createRecord('2cb45015', component.options)
    } else {
      api.reload('2cb45015', component.options)
    }
    module.hot.accept("./TextAreaDesigner.vue?vue&type=template&id=2cb45015&scoped=true&", function () {
      api.rerender('2cb45015', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/formField/TextAreaDesigner.vue"
export default component.exports